import React from 'react';

function ProfileImage({ src, alt }) {
  return (
    <>
      <img loading="lazy" src={src} alt={alt} className="profile-image" />
      <style jsx="true">{`
        .profile-image {
          aspect-ratio: 1;
          object-fit: contain;
          object-position: center;
          width: 36px;
          border-radius: 50px;
        }
      `}</style>
    </>
  );
}

export default ProfileImage;